import axios from 'axios'
import {API_ENDPOINT} from '../../config'

const all = (instance, params) => {
    instance.setState({ ...instance.state, loadingSites: true })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/services/internet/sites",
        headers: {
            "Authorization": instance.props.auth.authorization
        },
        data: params
    }).then(response => handleLoadSitesResponse(instance, response))
        .catch(error => {
            instance.setState({
                ...instance.state,
                loadingSites: false
            })
            alert(error)
        })
}

const handleLoadSitesResponse = (instance, response) => {
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingSites: false,
                sites: response.data.data.sites,
                total: response.data.data.size
            })
            break;
        case 403:
            instance.props.history.push('/auth/login')
            break;
        default:
            instance.setState({
                ...instance.state,
                loadingSites: false
            })
            alert(response.data.message)
    }
}

const one = (instance, params) => {
    instance.setState({ ...instance.state, loadingSite: true })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/services/internet/site",
        headers: {
            "Authorization": instance.props.auth.authorization
        },
        data: params
    }).then(response => handleLoadSiteResponse(instance, response))
        .catch(error => {
            instance.setState({
                ...instance.state,
                loadingSite: false
            })
            alert(error)
        })
}

const handleLoadSiteResponse = (instance, response) => {
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingSite: false,
                site: response.data.data.site
            })
            break;
        case 403:
            instance.props.history.push('/auth/login')
            break;
        default:
            instance.setState({
                ...instance.state,
                loadingSite: false
            })
            alert(response.data.message)
    }
}

const SiteDatasource = () => {
    return {
        all: (instance, params) => all(instance, params),
        one: (instance, params) => one(instance, params)
    }
}

export default SiteDatasource